import React from 'react';
import { Route } from 'react-router-dom';

import PublicLayout from '../../shared/public/layouts/Public.layout';
import { BASE_PUBLIC_V2_PATH } from '../../shared/public/constants/path.constants';
import PublicEditorialRoutes from '../../editorial/routes/public-editorial.routes';
import PublicAuthenticationRoutes from '../../authentication/routes/public-authentication.routes';

// Les routes de chaque module se montent en enfants du layout, comme le fait `AdminRootRoutes`.
// Task 11 will plug PublicProductsRoutes / PublicBasketsRoutes in as children here.
export default function PublicRootRoutes() {
  return (
    <Route path={BASE_PUBLIC_V2_PATH}>
      <PublicLayout>
        <PublicEditorialRoutes />
        <PublicAuthenticationRoutes />
      </PublicLayout>
    </Route>
  );
}
